import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import appconst from "./../../lib/appconst";

interface DeliveryNoteState extends ListState<any> {
    lineTotalCount: number,
    lineCurrentPage: number,
    linePageSize: number,
    lineLoading: boolean,
    serialTotalCount: number,
    serialCurrentPage: number,
    serialPageSize: number,
    serialLoading: boolean,
   
}
class DeliveryNoteModule extends ListModule<DeliveryNoteState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        lineTotalCount:0,
        lineCurrentPage:1,
        linePageSize:10,
        lineLoading:false,
        serialTotalCount:0,
        serialCurrentPage:1,
        serialPageSize:10,
        serialLoading:false,
    }
    actions = {
        async getAll(context: ActionContext<DeliveryNoteState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/DeliveryNote/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async get(context: ActionContext<DeliveryNoteState, any>, payload: any) {
            let reponse=await Ajax.get('/api/services/app/DeliveryNote/GetDetail?Id='+payload.data.id );
            return reponse.data.result;
        },
        async getLineSerials(context: ActionContext<DeliveryNoteState, any>, payload: any) {
            let reponse=await Ajax.get(`/api/services/app/DeliveryNote/${payload.data.id}/serials` );
            return reponse.data.result as [];
        },
        async return(context: ActionContext<DeliveryNoteState, any>, payload: any) {
            await Ajax.put(`/api/services/app/DeliveryNote/${payload.data.id}/return`);
        },
        async export(context:ActionContext<DeliveryNoteState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/`+payload.data.id+`/delivery-note`, "_blank");    
        },
        async exportMaThungOfDn(context:ActionContext<DeliveryNoteState,any>,payload:any){
            var url = `${appconst.remoteServiceBaseUrl}export/export-main-serials-of-dn${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
                return {
                    name: key,
                    value: payload.data[key]
                }
            }), true)}`;
            window.open(url, "_blank");    
        },
    };
    mutations = {
        setLineLoading(state: DeliveryNoteState, isLoading: boolean) {
            state.lineLoading = isLoading;
        },
        setSerialLoading(state: DeliveryNoteState, isLoading: boolean) {
            state.serialLoading = isLoading;
        },
        setCurrentPage(state: DeliveryNoteState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: DeliveryNoteState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setGiftCurrentPage(state: DeliveryNoteState, page: number) {
            state.serialCurrentPage = page;
        },
        setGiftPageSize(state: DeliveryNoteState, pagesize: number) {
            state.serialPageSize = pagesize;
        },
        setGiftTotalCount(state: DeliveryNoteState, count: number) {
            state.serialTotalCount = count;
        },
        setLineCurrentPage(state: DeliveryNoteState, page: number) {
            state.lineCurrentPage = page;
        },
        setLinePageSize(state: DeliveryNoteState, pagesize: number) {
            state.linePageSize = pagesize;
        },
        setLineTotalCount(state: DeliveryNoteState, count: number) {
            state.lineTotalCount = count;
        },
        refreshListData(state: DeliveryNoteState)
        {
            state.list = new Array<any>();
        },
    }
}
const deliveryNoteModule = new DeliveryNoteModule();
export default deliveryNoteModule;